<template>
    <div class="section__title__box">
        <h4 class="title">Organizations Management</h4>
        <div class="rlms-table-filters">
            <div class="rlms-tf-actions">
                <div class="input-icon-group input-icon-right">
                    <input type="search" placeholder="Search..." v-model.trim="search" @input="handleSearch">
                    <img class="rlms-input-icon" src="@/assets/images/search.svg">
                </div>
            </div>
        </div>
    </div>
    <div class="rlms-table" style="width: 100%;">
        <div class="rlms-table-inner">
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Created</th>
                        <th>Learners Count</th>
                        <th>Regressions</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="organizations?.length > 0">
                        <tr v-for="organization in organizations" :key="organization?.id">
                            <td>#{{ organization?.id }}</td>
                            <td>{{ organization?.name }}</td>
                            <td>{{ formatDate(organization?.created_at, 'MMM d, Y') }}</td>
                            <td>{{ organization?.learners_count }}</td>
                            <td><p>{{ organization?.regressions ? 'Enabled' : 'Disabled' }}</p></td>
                            <td>
                                <div class="action__tab">
                                    <div class="action__btn">
                                        <RouterLink :to="`/admin/organizations/${organization?.id}`" class="">
                                            <span class="btn__text">View</span>
                                            <span class="btn__arrow">
                                                <img src="@/assets/images/arrow-right.svg" alt="Arrow">
                                            </span>
                                        </RouterLink>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="8">
                                <div class="rlms-flex rlms-flex-col rlms-gap-30 rlms-text-center">
                                    <img :src="noAssessmentsImg" class="rlms-mx-auto" style="width: 100px">
                                    <p v-if="search || status">No organizations found for the selected search or filter criteria.</p>
                                    <p v-else>No organizations available.</p>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
    <div class="rlms-w-100">
        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'" :next-text="'>'"
            :container-class="'pagination'" :page-class="'page-item'" :active-class="'active-page'" v-if="totalPages > 1" />
    </div>
</template>
<script setup>
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { debounce } from '@/utils/debounce';
import { formatDate } from '@/utils/format-helpers';
import { handleError } from '@/utils/handleError';
import { onMounted, ref, watch } from 'vue';
import paginate from 'vuejs-paginate-next';
import noAssessmentsImg from '@/assets/images/no-assessments.png';

const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);
const status = ref("");
const search = ref("");

const organizations = ref([]);
const loader = useLoaderStore();


const getData = async () => {
    try {
        loader.show();

        const { data } = await api.get(`admin/organizations`, {
            params: {
                page: page.value,
                per_page: 10,
                status: status.value,
                search: search.value,
            }
        });

        organizations.value = data?.data?.data || [];

        totalPages.value = data?.data?.last_page ?? 1;
        totalItems.value = data?.data?.total ?? 0;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

onMounted(async () => await getData());

watch(page, () => getData());

watch([status], () => {
    page.value = 1
    getData()
});

const handleSearch = debounce(function () {
    page.value = 1;
    getData();
}, 400);

</script>